enum ActionsTypes {
    CREATE_SUBSCRIPTION_DETAILS_CARD = 'CREATE_SUBSCRIPTION_DETAILS_CARD',
    UPDATE_SUBSCRIPTION_DETAILS_CARD = 'UPDATE_SUBSCRIPTION_DETAILS_CARD',
}

export type ActionType = keyof typeof ActionsTypes;

export default ActionsTypes;
